var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-reports-list tab-table p-2"},[_c('condition-reports-table',{attrs:{"inventory":_vm.inventory,"change-permission":"change_condition_report","delete-permission":"delete_condition_report"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }